import pick from "lodash/pick";

import { MARKER_CIRCLE_SCALE } from "../marker-circle";

export const MARKER_ASSET_SCALE = pick(MARKER_CIRCLE_SCALE, ["DEFAULT", "LG"]);
